import {genqlBuilder} from "@/core/graphql/genql/builder"

import {MutationGenqlSelection, VorderDeliveryCalculateResult} from "../schema"

import {MutationVorderDeliveryCalculateArgs} from "../schema"

export type MutationVorderDeliveryCalculateVars = MutationVorderDeliveryCalculateArgs

export function vorderDeliveryCalculateMutation(mutation: MutationGenqlSelection['vorder_delivery_calculate'] | null) {            
    return {
      build: (variables: MutationVorderDeliveryCalculateVars) => genqlBuilder.build(mutation ? {vorder_delivery_calculate: mutation} : {__scalar: true}, {vorder_delivery_calculate: variables}),  
      mutate: (variables: MutationVorderDeliveryCalculateVars) => ({} as Promise<VorderDeliveryCalculateResult>),
      _variables: {} as MutationVorderDeliveryCalculateVars,
      _result: {} as VorderDeliveryCalculateResult,
    }
}

export type MutationVorderDeliveryCalculate = {
  builder: (variables: MutationVorderDeliveryCalculateVars) => MutationGenqlSelection,
  selection: MutationGenqlSelection['vorder_delivery_calculate'],
  variables: MutationVorderDeliveryCalculateVars,
  result: VorderDeliveryCalculateResult
}

export default vorderDeliveryCalculateMutation